import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-users'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import UserAdmin from '/components/account/users'

const AccountManagementUsers = () => {

  const navigate = useNavigate()

  const { client,user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="User Management" HelpText={HelpText} heading="User Management" menu={<Menu client={client} user={user}/>}>
      <div className='flex flex-col'>
        <UserAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementUsers